import React from 'react';
import AuthService from 'library/authService/auth-service';
import { Tabbed } from 'components/Page';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Permissions } from 'components/Permissions';
import config from './config';

const MyAccount = () => {
  const user = AuthService.whoami() || {};

  return (
    <div className="bhp-users bhp-container">
      <Permissions.Consumer>
        {({ permissions }) => (
          <Tabbed
            reducer={{
              item: REDUCER_KEY.userAccount,
              list: REDUCER_KEY.peopleData
            }}
            item={user}
            tabPosition="left"
            isEditMode
            config={{
              ...config,
              parent: {
                id: user.id
              },
              commands: {
                ...config.commands,
                showCancelButton: permissions.CanAdminProfile()
                  .hasPermissions()
              }
            }}
            permissions={permissions}
          />
        )}
      </Permissions.Consumer>
    </div>
  );
};

export default MyAccount;
